import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAltSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Select from "react-select";

import styles from "../styles/style.module.css";
import modalStyles from "../styles/modals.module.css";
import commonStyles from "../../../lib/common/common.module.css";
import { APP_ROUTES, LOCAL_CONSTANTS } from "../../../lib/constants";
import { UserTypes } from "../../../interfaces";
import { list, update, updateOrder, getIccidByVariant } from "../api";
import Layout from "../../../ui/layout";
import { IMAGES } from "../../../assets/images";
import { DropDownMenu, ActionButton, Pagination, Popup } from "../../../ui";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import SelectColumns from "../../../ui/Popup/selectColumn";
import { getRole } from "../../../lib/common/common";
import { Button, Modal, Dropdown as AntDropdown } from "antd";
import LogisticsModal from "../components/LogisticsModal";
import IccidModal from "../components/IccidModal";
import { Color } from "antd/es/color-picker";
import { exportToExcelInChunks } from "../../../utils/excel.export";

// Orders page-only table headers (extends the shared CustomersTableHeaders with a "Created Date" column
// without affecting other pages that reuse CustomersTableHeaders).
const ORDER_TABLE_HEADERS = [
  ...LOCAL_CONSTANTS.CustomersTableHeaders,
  { value: "Created Date", label: "Created Date" },
];

const Orders = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {   
  //   const roles: any = window.localStorage.getItem("admin_roles")
  //   if (roles == 4 || roles == 5) return navigate(APP_ROUTES.PARTNERS);
  // },[])
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [search, setSearch] = useState < string | null > (null);
  const [order, setSortOrder] = useState < number > (0);
  const [sortBy, setSortColumn] = useState < string > ("");
  const [blockedAccounts, setBlockedAccounts] = useState < boolean | null > (null);
  const [verifiedEmailAccount, setVerifiedEmailAccounts] = useState < boolean | null > (null);
  const [verifiedPhoneNoAccount, setVerifiedPhoneNoAccounts] = useState < boolean | null > (null);
  const [startDate, setStartDate] = useState < string > ("");
  const [endDate, setEndDate] = useState < string > ("");
  const [show, setShow] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<any[]>(
    ORDER_TABLE_HEADERS.filter(
      (h, idx, arr) =>
        h.value !== "Action" &&
        h.value !== "DOB" &&
        h.value !== "Brand" &&
        (h.value !== "Phone" || arr.findIndex(x => x.value === "Phone") === idx)
    )
  );
  const [users, setUsers] = useState < { list: any[]; count: number } > ({
    list: [],
    count: 0,
  });

  const [loading, setLoading] = useState < boolean > (true);
  const [dialog, setDialog] = useState({ show: false, id: "", status: false });
  const [logisticsModal, setLogisticsModal] = useState < {
    visible: boolean;
    orderData: any;
    isEditing: boolean;
  } > ({
    visible: false,
    orderData: null,
    isEditing: false
  });
  const [logisticsForm, setLogisticsForm] = useState({
    logisticsPartner: '',
    link: '',
    invoiceNo: '',
    amount: '',
    awb: '',
    dispatchDate: '',
    expectedDeliveryDate: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [iccidModal, setIccidModal] = useState < {
    visible: boolean;
    orderData: any
  } > ({
    visible: false,
    orderData: null
  });
  const [iccidList, setIccidList] = useState < any[] > ([]);
  const [selectedIccids, setSelectedIccids] = useState < string[] > ([]);
  const [iccidLoading, setIccidLoading] = useState < boolean > (false);

  const [statusUpdating, setStatusUpdating] = useState<string | null>(null);
  const [orderStatus, setOrderStatus] = useState<string | null>(null);

  const [editingAddressId, setEditingAddressId] = useState<string | null>(null);
  const [newAddressLine2, setNewAddressLine2] = useState<string>("");
  const [addressUpdating, setAddressUpdating] = useState<string | null>(null);

  const [editingAddress1Id, setEditingAddress1Id] = useState<string | null>(null);
  const [newAddressLine1, setNewAddressLine1] = useState<string>("");
  const [address1Updating, setAddress1Updating] = useState<string | null>(null);

  const [manualModalVisible, setManualModalVisible] = useState(false);
  const [manualInput, setManualInput] = useState("");
  const [manualSubmitting, setManualSubmitting] = useState(false);

  const [editingTravelDateId, setEditingTravelDateId] = useState<string | null>(null);
  const [newTravelDate, setNewTravelDate] = useState<string>("");
  const [travelDateUpdating, setTravelDateUpdating] = useState<string | null>(null);

  const [orderId, setOrderId] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");

  const [status, setStatus] = useState("");

  // For Export to CSV
  const [exporting, setExporting] = useState<boolean>(false);

  const [editingSimNumberId, setEditingSimNumberId] = useState<string | null>(null);
  const [newSimNumber, setNewSimNumber] = useState<string>("");
  const [simNumberUpdating, setSimNumberUpdating] = useState<string | null>(null);

  // State for cancel remark popup (use 'remarks' key everywhere)
  const [cancelRemarkModal, setCancelRemarkModal] = useState({ visible: false, orderId: '', remarks: '' });
  const [cancelRemarkSubmitting, setCancelRemarkSubmitting] = useState(false);



  const listUsers = (
    pageIndex = pagination.skip
  ) => {
    let query: any = {
      page: pageIndex + 1,
      limit: pagination.limit,
    };

    if (orderId) query['orderId'] = orderId;
    if (email) query['email'] = email;
    if (phoneNumber) query['phone'] = phoneNumber;
    if (name) query['name'] = name;

    if (status) query['status'] = status;
    if (startDate) query['startDate'] = startDate;
    if (endDate) query['endDate'] = endDate;

    list(query)
      .then(({ data }) => {
        setUsers({ list: data.data, count: data.total });
        setLoading(false);
      })
      .catch((error) => {
        const err = error as any;
        console.error('API Error:', err, err?.message, err?.response);
        toast.error(err?.message || 'Failed to fetch orders');
        setLoading(false);
      });
  };
  const handleSelectColumn = () => {
    setShow(true);
  }
  const [searchObject, setSearchObject] = useState({});
  useEffect(() => {
    setLoading(true);
    const debounceSearch = setTimeout(() => {
      listUsers();
    }, 500);
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [pagination, orderId, email, phoneNumber, name, status, startDate, endDate]);

  useEffect(() => {
    console.log(searchObject, "searchObject")
  }, [searchObject]);


  const blockUnblockUser = () => {
    const payload = {
      userId: dialog.id,
      isBlocked: dialog.status,
    };
    toast.promise(
      update(payload),
      {
        pending: {
          render() {
            return LOCAL_CONSTANTS.updatingUser;
          },
        },
        success: {
          render() {
            let tempUser = users.list;
            let index = tempUser.findIndex((item) => item._id === dialog.id);

            tempUser[index].isBlocked = !tempUser[index].isBlocked;

            setUsers({ ...users, list: tempUser });

            setDialog({ show: false, id: "", status: false });
            return dialog.status
              ? LOCAL_CONSTANTS.userBlockedSuccessfully
              : LOCAL_CONSTANTS.userUnblockedSuccessfully;
          },
        },
        error: {
          render() {
            return LOCAL_CONSTANTS.errorOnUpdatingUser;
          },
        },
      });
  };

  const handleSort = (column: string) => {
    setSortColumn(column);
    setSortOrder(
      order === LOCAL_CONSTANTS.descKey
        ? LOCAL_CONSTANTS.ascKey
        : LOCAL_CONSTANTS.descKey
    );
    const query = {
      ...pagination,
      search,
      order:
        order === LOCAL_CONSTANTS.descKey
          ? LOCAL_CONSTANTS.ascKey
          : LOCAL_CONSTANTS.descKey,
      sortBy: column,
    };
    list(query).then(({ data }) => {
      setUsers({
        list: data.data
        , count: data.count
      });
      setLoading(false);
    }).catch((error) => {
      const err = error as any;
      console.error('API Error:', err, err?.message, err?.response);
      toast.error(err?.message || 'Failed to fetch orders');
      setLoading(false);
    });
  };

  const handleLogisticsFormChange = (field: string, value: string) => {
    setLogisticsForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleLogisticsSuccess = () => {
    setLogisticsModal({ visible: false, orderData: null, isEditing: false });
    setLogisticsForm({
      logisticsPartner: '',
      link: '',
      invoiceNo: '',
      amount: '',
      awb: '',
      dispatchDate: '',
      expectedDeliveryDate: '',
    });
    listUsers();
  };

  const handleLogisticsClose = () => {
    setLogisticsModal({ visible: false, orderData: null, isEditing: false });
    setLogisticsForm({
      logisticsPartner: '',
      link: '',
      invoiceNo: '',
      amount: '',
      awb: '',
      dispatchDate: '',
      expectedDeliveryDate: '',
    });
  };

 

  const handleIccidModalOpen = (orderData: any) => {
    setIccidModal({ visible: true, orderData });
  };

  const handleIccidSuccess = () => {
    setIccidModal({ visible: false, orderData: null });
    setSelectedIccids([]);
    setIccidList([]);
    listUsers();
  };

  const handleIccidClose = () => {
    setIccidModal({ visible: false, orderData: null });
    setSelectedIccids([]);
    setIccidList([]);
  };

  // const handleSelectAllIccids = () => {
  //   if (selectedIccids.length === iccidList.length) {
  //     setSelectedIccids([]);
  //   } else {
  //     setSelectedIccids(iccidList.map(item => item._id || item.id));
  //   }
  // };

  // Order status options for dropdown
  const orderStatusOptions = [
    { value: 'Pending', label: "Pending" },
    { value: 'Packed', label: "Packed" },
    { value: 'In Transit', label: "In Transit" },
    { value: 'Delivered', label: "Delivered" },
    { value: 'Activated', label: "Activated" },
    { value: "Discussed", label: "Discussed"},
    { value: 'Canceled', label: "Canceled" },
    { value: 'Convert2Esim', label: "Convert2Esim" }
  ];

  // Function to get status label from value
  const getStatusLabel = (statusValue: string) => {
    const status = orderStatusOptions.find(option => option.value === statusValue);
    return status ? status.label : "N/A";
  };

  // Function to handle status update
  const handleStatusUpdate = async (orderId: string, newStatus: string) => {
    setStatusUpdating(orderId);
    
    try {
      const payload = {
        status: newStatus
      };
      
      await updateOrder(orderId, payload);
      
      // Update the local state
      const updatedUsers = users.list.map(item => 
        item._id === orderId ? { ...item, status: newStatus } : item
      );
      setUsers({ ...users, list: updatedUsers });
      
      toast.success('Order status updated successfully');
    } catch (error) {
      const err = error as any;
      console.error('Error:', err, err?.message, err?.response);
      toast.error(err?.message || 'Failed to update order status');
    } finally {
      setStatusUpdating(null);
    }
  };

  const handleResetFilters = () => {
    setOrderId("");
    setEmail("");
    setPhoneNumber("");
    setName("");
    setStatus("");
    setStartDate("");
    setEndDate("");
    setPagination(prev => ({ ...prev, skip: 0 }));
  };

  const handleEditAddress = (id: string, currentAddress: string) => {
    setEditingAddressId(id);
    setNewAddressLine2(currentAddress);
  };

  const handleAddressLine2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewAddressLine2(e.target.value);
  };

  const handleSaveAddress = async (id: string) => {
    setAddressUpdating(id);
    try {
      await updateOrder(id, { address_line2: newAddressLine2 });
      // Update local state
      const updatedUsers = users.list.map(item =>
        item._id === id ? { ...item, address_line2: newAddressLine2 } : item
      );
      setUsers({ ...users, list: updatedUsers });
      toast.success('Address updated successfully');
      setEditingAddressId(null);
    } catch (error) {
      toast.error('Failed to update Address Line 2');
    } finally {
      setAddressUpdating(null);
    }
  };

  const handleCancelEditAddress = () => {
    setEditingAddressId(null);
    setNewAddressLine2("");
  };

  const handleEditAddress1 = (id: string, currentAddress: string) => {
    setEditingAddress1Id(id);
    setNewAddressLine1(currentAddress);
  };

  const handleAddressLine1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewAddressLine1(e.target.value);
  };

  const handleSaveAddress1 = async (id: string) => {
    setAddress1Updating(id);
    try {
      await updateOrder(id, { address_line1: newAddressLine1 });
      // Update local state
      const updatedUsers = users.list.map(item =>
        item._id === id ? { ...item, address_line1: newAddressLine1 } : item
      );
      setUsers({ ...users, list: updatedUsers });
      toast.success('Address updated successfully');
      setEditingAddress1Id(null);
    } catch (error) {
      toast.error('Failed to update Address Line 1');
    } finally {
      setAddress1Updating(null);
    }
  };

  const handleCancelEditAddress1 = () => {
    setEditingAddress1Id(null);
    setNewAddressLine1("");
  };


  const handleEditTravelDate = (id: string, currentDate: string) => {
    setEditingTravelDateId(id);
    setNewTravelDate(currentDate ? moment.utc(currentDate).format("YYYY-MM-DD") : "");
  };

  const handleTravelDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewTravelDate(e.target.value);
  };

  const handleSaveTravelDate = async (id: string) => {
    setTravelDateUpdating(id);
    try {
      await updateOrder(id, { travelDate: newTravelDate });
      // Update local state
      const updatedUsers = users.list.map(item =>
        item._id === id ? { ...item, travelDate: newTravelDate } : item
      );
      setUsers({ ...users, list: updatedUsers });
      toast.success('Travel Date updated successfully');
      setEditingTravelDateId(null);
    } catch (error) {
      toast.error('Failed to update Travel Date');
    } finally {
      setTravelDateUpdating(null);
    }
  };

  const handleCancelEditTravelDate = () => {
    setEditingTravelDateId(null);
    setNewTravelDate("");
  };

  const handleExportByDateRange = async () => {
    setExporting(true);
    try {
      // Only send whichever date(s) are actually filled — backend supports
      // startDate/endDate independently, both are not required together
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      const url = `https://api-cb.commbitz.com/zolve-admin/zolve-orders/export-csv?${params.toString()}`;
      const response = await fetch(url, { method: "GET" });
      if (!response.ok) throw new Error("Failed to export CSV");
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const fileSuffix = startDate && endDate
        ? `${startDate}_to_${endDate}`
        : startDate
        ? `from_${startDate}`
        : `till_${endDate}`;
      link.download = `orders_${fileSuffix}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("CSV exported successfully");
    } catch (error) {
      toast.error("Failed to export CSV");
    } finally {
      setExporting(false);
    }
  };

  // Export current page — independent of date range, exports only the rows
  // currently loaded/visible on this page (respects active filters & selected columns)
  const getExportCellValue = (item: any, columnValue: string) => {
    switch (columnValue) {
      case "Logistics":
        return item?.logisticPartnerDetails?.logisticsPartner || "N/A";
      case "Passport Front":
        return item.documents?.passportFront || "N/A";
      case "Passport Back":
        return item.documents?.passportBack || "N/A";
      case "Visa":
        return item.documents?.visa || "N/A";
      case "Order Id":
        return item.orderId || "N/A";
      case "Sim Type":
        return item.simType === 1 || item.simType === "1"
          ? "Physical SIM"
          : item.simType === 2 || item.simType === "2"
          ? "eSIM"
          : "N/A";
      case "Transaction Date":
        return item.createdAt ? moment.utc(item.createdAt).format("DD/MM/YYYY") : "N/A";
      case "Created Date":
        return item.createdAt ? moment.utc(item.createdAt).format("DD/MM/YYYY HH:mm") : "N/A";
      case "Travel Date":
        return item.travelDate ? moment.utc(item.travelDate).format("DD/MM/YYYY") : "N/A";
      case "ICCID":
        return item.iccid || "N/A";
      case "API Id":
        return "N/A";
      case "User Id":
        return item.partnerUserId?._id || "N/A";
      case "Name":
        return item.partnerUserId
          ? `${item.partnerUserId.firstName} ${item.partnerUserId.lastName}`
          : "N/A";
      case "Phone":
        return item.partnerUserId?.phoneNumber || item.phone || "N/A";
      case "Address Line 1":
        return item.address_line1 || "N/A";
      case "Address Line 2":
        return item.address_line2 || "N/A";
      case "City":
        return item?.city || "N/A";
      case "Pincode":
        return item?.pincode || "N/A";
      case "State":
        return item?.state || "N/A";
      case "email":
      case "Email":
        return item.partnerUserId?.email || "N/A";
      case "Quantity":
        return item.quantity || "N/A";
      case "Plan":
        return item.variantDetails?.zolveCode || "N/A";
      case "Sim Number":
        return item.simNumber || "N/A";
      case "Order Type":
        return item.orderType || "N/A";
      case "Status":
        return getStatusLabel(item?.status || "Pending");
      default:
        return "N/A";
    }
  };

  const handleExportCurrentPage = () => {
    if (!users.list || users.list.length === 0) {
      toast.error("No records on this page to export");
      return;
    }
    const exportColumns = selectedColumns.filter(
      (col: any) => col.label !== "Actions" && col.label !== "Action"
    );
    const customHeader = exportColumns.map((col: any) => col.label);
    const getData = users.list.map((item) => {
      const row: Record<string, any> = {};
      exportColumns.forEach((col: any) => {
        row[col.value] = getExportCellValue(item, col.value);
      });
      return row;
    });
    exportToExcelInChunks(getData, `orders_page_${pagination.skip + 1}`, 300, customHeader);
    toast.success("Current page exported successfully");
  };

  // Single export entry point:
  // - If either Start Date or End Date is filled -> export via date API (server-side CSV,
  //   backend supports startDate/endDate independently, both are not required together)
  // - If neither date is filled -> export just the currently open/loaded page (client-side)
  const handleExport = () => {
    if (startDate || endDate) {
      handleExportByDateRange();
    } else {
      handleExportCurrentPage();
    }
  };

  const handleEditSimNumber = (id: string, currentSimNumber: string) => {
    setEditingSimNumberId(id);
    setNewSimNumber(currentSimNumber || "");
  };

  const handleSimNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewSimNumber(e.target.value);
  };

  const handleSaveSimNumber = async (id: string) => {
    setSimNumberUpdating(id);
    try {
      await updateOrder(id, { simNumber: newSimNumber });
      // Update local state
      const updatedUsers = users.list.map(item =>
        item._id === id ? { ...item, simNumber: newSimNumber } : item
      );
      setUsers({ ...users, list: updatedUsers });
      toast.success('Sim Number updated successfully');
      setEditingSimNumberId(null);
    } catch (error) {
      toast.error('Failed to update Sim Number');
    } finally {
      setSimNumberUpdating(null);
    }
  };

  const handleCancelEditSimNumber = () => {
    setEditingSimNumberId(null);
    setNewSimNumber("");
  };

  return (
    <>
      <Layout title="Orders">
        <div className={commonStyles.tableData}>
          <div className={commonStyles.topFilter}>
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "14px", rowGap: "12px" }}
            >
              <div style={{ width: "200px" }}>
                <Select
                  options={orderStatusOptions}
                  onChange={(option) => setStatus(option ? option.value : "")}
                  value={orderStatusOptions.find((o) => o.value === status) || null}
                  placeholder="Status"
                  isSearchable={false}
                  isClearable
                  className="w-100"
                  styles={{
                    control: (base) => ({ ...base, minHeight: 40, height: 40, borderRadius: 4 }),
                    valueContainer: (base) => ({ ...base, height: 40, padding: "0 8px" }),
                    indicatorsContainer: (base) => ({ ...base, height: 40 }),
                  }}
                />
              </div>
              <input
                type="date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
                onClick={(e) => { try { (e.currentTarget as HTMLInputElement).showPicker?.(); } catch {} }}
                min="2000-01-01"
                max="2099-12-31"
                style={{
                  height: 40,
                  width: 170,
                  minWidth: 170,
                  padding: "0 10px",
                  borderRadius: 4,
                  border: "1px solid #333",
                  boxSizing: "border-box",
                  fontSize: 14,
                  lineHeight: "40px",
                  colorScheme: "light",
                  cursor: "pointer",
                }}
                placeholder="Start Date"
              />
              <input
                type="date"
                value={endDate}
                onChange={e => {
                  if (startDate && e.target.value < startDate) {
                    toast.error("End date cannot be before start date");
                    return;
                  }
                  setEndDate(e.target.value);
                }}
                onClick={(e) => { try { (e.currentTarget as HTMLInputElement).showPicker?.(); } catch {} }}
                min="2000-01-01"
                max="2099-12-31"
                style={{
                  height: 40,
                  width: 170,
                  minWidth: 170,
                  padding: "0 10px",
                  borderRadius: 4,
                  border: "1px solid #333",
                  boxSizing: "border-box",
                  fontSize: 14,
                  lineHeight: "40px",
                  colorScheme: "light",
                }}
                placeholder="End Date"
              />
              <button
                onClick={handleExport}
                disabled={exporting}
                title={startDate && endDate ? "Exports records within the selected date range" : "Exports the currently open page"}
                style={{
                  height: 40,
                  background: "#00ff99",
                  color: "#000",
                  border: "none",
                  borderRadius: 4,
                  padding: "0 18px",
                  fontWeight: 600,
                  cursor: exporting ? "not-allowed" : "pointer",
                  opacity: exporting ? 0.5 : 1
                }}
              >
                {exporting ? "Exporting..." : "Export to CSV"}
              </button>
              <button
                onClick={handleResetFilters}
                className={styles.loyalityPointBtn}
                style={{ height: 40, padding: "0 28px" }}
              >
                Reset
              </button>
            </div>
          </div>
          <div className={styles.scrollTable}>
            <table>
              <thead>
                <tr>
                  {selectedColumns?.map((header: UserTypes.TableHeader) => (
                    <th
                      className={`${["fullName", "phoneNumber"].includes(header?.value)
                        ? "cursor-pointer"
                        : ""
                      }`}
                      onClick={() => {
                        if (["fullName", "phoneNumber"].includes(header?.value)) {
                          handleSort(header?.value);
                        }
                      }}
                      key={header?.value}
                    >
                      {header?.label}
                      {/* {sortBy === header?.value &&
                        ["fullName", "phoneNumber"].includes(header?.value) &&
                        renderSortIcon(header?.value)} */}
                      <div className={commonStyles.topFilter}>
                        <div className={styles.date_calender}>
                          {header.label !== "Actions" && !header.label.includes("Date") && header.label !== "Role" && header.label !== "Blocked" && (
                            header.label === "Order Id" ? (
                              <input
                                type="text"
                                placeholder="Order Id"
                                value={orderId}
                                onChange={e => {
                                  setOrderId(e.target.value);
                                  setPagination(prev => ({ ...prev, skip: 0 }));
                                }}
                              />
                            ) : header.label === "Email" ? (
                              <input
                                type="text"
                                placeholder="Email"
                                value={email}
                                onChange={e => {
                                  setEmail(e.target.value);
                                  setPagination(prev => ({ ...prev, skip: 0 }));
                                }}
                              />
                            ) : header.label === "Phone" ? (
                              <input
                                type="text"
                                placeholder="Phone Number"
                                value={phoneNumber}
                                onChange={e => {
                                  setPhoneNumber(e.target.value);
                                  setPagination(prev => ({ ...prev, skip: 0 }));
                                }}
                              />
                            ) : header.label === "Name" ? (
                              <input
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={e => {
                                  setName(e.target.value);
                                  setPagination(prev => ({ ...prev, skip: 0 }));
                                }}
                              />
                            ) : (
                              <input
                                onChange={(e) => {
                                  setSearchObject({ ...searchObject, [header.value]: e.target.value });
                                }}
                              />
                            )
                          )}

                        </div>
                        {header.label === "Role" && <div className="w-100">

                          <Select
                            options={LOCAL_CONSTANTS.ZOLVE_ROLES}
                            onChange={(response) => {
                              if (response) {
                                let pageIndex = 0;
                                let status = response.value;

                                setSearchObject({ ...searchObject, [header.value]: response.value });
                                // listUsers(pageIndex, blockedAccounts, verifiedPhoneNoAccount, status);
                              }
                            }}
                            defaultValue={{ value: "", label: "Select Role" }}
                            className="w-100"
                          />
                        </div>}
                        {header.label === "Blocked" && <div className="w-">

                          <Select
                            options={LOCAL_CONSTANTS.blockedAccounts}
                            onChange={(response) => {
                              if (response) {
                                let pageIndex = 0;
                                let status = response.value;

                                setSearchObject({ ...searchObject, [header.value]: response.value });
                                // listUsers(pageIndex, blockedAccounts, verifiedPhoneNoAccount, status);
                              }
                            }}
                            defaultValue={LOCAL_CONSTANTS.blockedAccounts[0]}
                            className="w-100"
                          />
                        </div>}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={selectedColumns.length} align="center" className={styles.loadingText}>
                      {LOCAL_CONSTANTS.loading}
                    </td>
                  </tr>
                )}
                {!loading && users.list?.length === 0 && (
                  <tr>
                    <td colSpan={selectedColumns.length} align="center">
                      No User Found
                    </td>
                  </tr>
                )}
                {!loading &&
                  users.list.map((item) => (
                    <tr>{selectedColumns.map((rr) => {
                      if (rr.value === "Logistics") {
                        if (item?.status === "Convert2Esim" || (item?.simType === 2 || item?.simType === "2")) {
                          return <td style={{ color: '#666', fontStyle: 'italic' }}>N/A</td>;
                        }
                        
                        return <td>
                          {item?.logisticPartnerDetails?.logisticsPartner ? (
                            <>
                               <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span>{item.logisticPartnerDetails.logisticsPartner}</span>
                                {item.status !== "Delivered" && (
                                  <Button
                                    onClick={() => {
                                      setLogisticsModal({ 
                                        visible: true, 
                                        orderData: item, 
                                        isEditing: true 
                                      });
                                    }}
                                    className={modalStyles.tableActionButton}
                                    size="small"
                                  >
                                    Edit
                                  </Button>
                                )}
                              </div>
                            </>
                          ) : (
                            <Button 
                              onClick={() => setLogisticsModal({ 
                                visible: true, 
                                orderData: item, 
                                isEditing: false 
                              })} 
                              className={modalStyles.tableActionButton}
                              disabled={item.orderType === "B2B"}
                            >
                              Assign <i className="fas fa-edit"></i>
                            </Button>
                          )}
                        </td>
                      } else if (rr.value === "Passport Front") {
                        return <td>{item.documents ?
                          <span style={{ cursor: "pointer" }} onClick={() => {
                            window.open(item.documents.passportFront, "_blank");
                          }}>View Passport</span>

                          : "N/A"}</td>;
                      } else if (rr.value === "Passport Back") {
                        return <td>{item.documents ?
                          <span style={{ cursor: "pointer" }} onClick={() => {
                            window.open(item.documents.passportBack, "_blank");
                          }}>View Passport</span>

                          : "N/A"}</td>;
                      }  else if (rr.value === "Visa") {
                        return <td>{item.documents ?
                          <span style={{ cursor: "pointer" }} onClick={() => {
                            window.open(item.documents.visa, "_blank");
                          }}>View Visa</span>

                          : "N/A"}</td>;
                      } 
                       else if (rr.value === "Order Id") {
                        return <td>{item.orderId || "N/A"}</td>;
                      } else if (rr.value === "Sim Type") {
                        const simType = item.simType;
                        if (simType === 1 || simType === "1") {
                          return <td>Physical SIM</td>;
                        } else if (simType === 2 || simType === "2") {
                          return <td>eSIM</td>;
                        } else {
                          return <td>N/A</td>;
                        }
                      } else if (rr.value === "Transaction Date") {
                        return <td>{moment.utc(item.createdAt).format("DD/MM/YYYY")}</td>;
                      }
                      else if (rr.value === "Created Date") {
                        return <td>{item.createdAt ? moment.utc(item.createdAt).format("DD/MM/YYYY HH:mm") : "N/A"}</td>;
                      }
                      else if (rr.value === "Travel Date") {
                        if (editingTravelDateId === item._id) {
                          return (
                            <td>
                              <input
                                type="date"
                                min={new Date().toISOString().split('T')[0]}
                                value={newTravelDate}
                                onChange={handleTravelDateChange}
                                disabled={travelDateUpdating === item._id}
                                style={{ width: "120px" }}
                              />
                              <button
                                onClick={() => handleSaveTravelDate(item._id)}
                                disabled={travelDateUpdating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                {travelDateUpdating === item._id ? "Saving..." : "Save"}
                              </button>
                              <button
                                onClick={handleCancelEditTravelDate}
                                disabled={travelDateUpdating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                Cancel
                              </button>
                            </td>
                          );
                        } else {
                          return (
                            <td>
                              {item.travelDate ? moment.utc(item.travelDate).format("DD/MM/YYYY") : "N/A"}
                              <button
                                onClick={() => handleEditTravelDate(item._id, item.travelDate)}
                                style={{ marginLeft: "8px" }}
                              >
                                Edit
                              </button>
                            </td>
                          );
                        }
                      } else if (rr.value === "ICCID") {
                        return <td>
                          {item.iccid ? (
                            item.iccid
                          ) : (
                            <Button onClick={() => handleIccidModalOpen(item)} className={modalStyles.tableActionButton}>
                              Assign <i className="fas fa-edit"></i>
                            </Button>
                          )}
                        </td>
                      } else if (rr.value === "API Id") {
                        return <td>{"N/A"}</td>;
                      } else if (rr.value === "User Id") {
                        return <td>{item.partnerUserId._id}</td>;
                      } else if (rr.value === "Name") {
                        return <td>{item.partnerUserId.firstName + " " + item.partnerUserId.lastName}</td>;
                      } else if (rr.value === "Phone") {
                        return <td>{item.partnerUserId?.phoneNumber || item.phone || "N/A"}</td>;
                      } 
                      else if (rr.value === "Address Line 1") {
                        if (editingAddress1Id === item._id) {
                          return (
                            <td>
                              <input
                                type="text"
                                value={newAddressLine1}
                                onChange={handleAddressLine1Change}
                                disabled={address1Updating === item._id}
                                style={{ width: "120px" }}
                              />
                              <button
                                onClick={() => handleSaveAddress1(item._id)}
                                disabled={address1Updating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                {address1Updating === item._id ? "Saving..." : "Save"}
                              </button>
                              <button
                                onClick={handleCancelEditAddress1}
                                disabled={address1Updating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                Cancel
                              </button>
                            </td>
                          );
                        } else {
                          return (
                            <td>
                              {item.address_line1 || "N/A"}
                              <button
                                onClick={() => handleEditAddress1(item._id, item.address_line1 || "")}
                                style={{ marginLeft: "8px" }}
                              >
                                Edit
                              </button>
                            </td>
                          );
                        }
                      } 
                      // else if (rr.value === "Address Line1") {
                      //   return <td>{item?.address_line1},{item.address?.city}</td>;
                      // } 
                      else if (rr.value === "Address Line 2") {
                        if (editingAddressId === item._id) {
                          return (
                            <td>
                              <input
                                type="text"
                                value={newAddressLine2}
                                onChange={handleAddressLine2Change}
                                disabled={addressUpdating === item._id}
                                style={{ width: "120px" }}
                              />
                              <button
                                onClick={() => handleSaveAddress(item._id)}
                                disabled={addressUpdating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                {addressUpdating === item._id ? "Saving..." : "Save"}
                              </button>
                              <button
                                onClick={handleCancelEditAddress}
                                disabled={addressUpdating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                Cancel
                              </button>
                            </td>
                          );
                        } else {
                          return (
                            <td>
                              {item.address_line2 || "N/A"}
                              <button
                                onClick={() => handleEditAddress(item._id, item.address_line2 || "")}
                                style={{ marginLeft: "8px" }}
                              >
                                Edit
                              </button>
                            </td>
                          );
                        }
                      } else if (rr.value === "City") {
                        return <td>{item?.city || "N/A"}</td>;
                      } else if (rr.value === "Pincode") {
                        return <td>{item?.pincode || "N/A"}</td>;
                      } else if (rr.value === "DOB") {
                        return null;
                      } else if (rr.value === "Travel Date") {
                        if (editingTravelDateId === item._id) {
                          return (
                            <td>
                              <input
                                type="date"
                                min={new Date().toISOString().split('T')[0]}
                                value={newTravelDate}
                                onChange={handleTravelDateChange}
                                disabled={travelDateUpdating === item._id}
                                style={{ width: "120px" }}
                              />
                              <button
                                onClick={() => handleSaveTravelDate(item._id)}
                                disabled={travelDateUpdating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                {travelDateUpdating === item._id ? "Saving..." : "Save"}
                              </button>
                              <button
                                onClick={handleCancelEditTravelDate}
                                disabled={travelDateUpdating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                Cancel
                              </button>
                            </td>
                          );
                        } else {
                          return (
                            <td>
                              {item.travelDate ? moment.utc(item.travelDate).format("DD/MM/YYYY") : "N/A"}
                              <button
                                onClick={() => handleEditTravelDate(item._id, item.travelDate)}
                                style={{ marginLeft: "8px" }}
                              >
                                Edit
                              </button>
                            </td>
                          );
                        }
                      } else if (rr.value === "State") {
                        return <td>{item?.state || 'N/A'}</td>;
                      } else if (rr.value === "email") {
                        return <td>{item.partnerUserId.email}</td>;
                      }  else if (rr.value === "Quantity") {
                        return <td>{item.quantity|| "N/A"}</td>;
                      } else if (rr.value === "Plan") {
                        return <td>{item.variantDetails?.zolveCode|| "N/A"}</td>;
                      }  else if (rr.value === "brand") {
                        return null;
                      } else if (rr.value === "Sim Number") {
                        if (editingSimNumberId === item._id) {
                          return (
                            <td>
                              <input
                                type="text"
                                value={newSimNumber}
                                onChange={handleSimNumberChange}
                                disabled={simNumberUpdating === item._id}
                                style={{ width: "120px" }}
                              />
                              <button
                                onClick={() => handleSaveSimNumber(item._id)}
                                disabled={simNumberUpdating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                {simNumberUpdating === item._id ? "Saving..." : "Save"}
                              </button>
                              <button
                                onClick={handleCancelEditSimNumber}
                                disabled={simNumberUpdating === item._id}
                                style={{ marginLeft: "4px" }}
                              >
                                Cancel
                              </button>
                            </td>
                          );
                        } else {
                          return (
                            <td>
                              {item.simNumber || "N/A"}
                              <button
                                onClick={() => handleEditSimNumber(item._id, item.simNumber || "")}
                                style={{ marginLeft: "8px" }}
                              >
                                Edit
                              </button>
                            </td>
                          );
                        }
                      } else if (rr.value === "Order Type") {
                        return <td>{item.orderType || "N/A"}</td>;
                      } else if (rr.value === "Email") {
                        return <td>{item.partnerUserId?.email || "N/A"}</td>;
                      } else if (rr.value === "Status") {
                        const currentStatus = item?.status || "Pending"; // Default to Pending if no status
                        const statusLabel = getStatusLabel(currentStatus);
                        return (
                          <td>
                            <AntDropdown
                              menu={{
                                items: orderStatusOptions.map(option => ({
                                  key: option.value,
                                  label: option.label,
                                  onClick: () => {
                                    if (option.value === 'Canceled') {
                                      setCancelRemarkModal({ visible: true, orderId: item._id, remarks: '' });
                                    } else {
                                      handleStatusUpdate(item._id, option.value);
                                    }
                                  },
                                  disabled: statusUpdating === item._id
                                }))
                              }}
                              trigger={['click']}
                              disabled={statusUpdating === item._id}
                            >
                              <div 
                                style={{ 
                                  cursor: 'pointer', 
                                  padding: '4px 8px',
                                  borderRadius: '4px',
                                  backgroundColor: statusUpdating === item._id ? '#f5f5f5' : '#f0f0f0',
                                  border: '1px solid #d9d9d9',
                                  display: 'inline-block',
                                  minWidth: '80px',
                                  textAlign: 'center'
                                }}
                              >
                                {statusUpdating === item._id ? (
                                  <span>Updating...</span>
                                ) : (
                                  <span style={{ color: 'black' }}>{statusLabel}</span>
                                )}
                              </div>
                            </AntDropdown>
                          </td>
                        );
                      } else {
                        return <td>{"N/A"}</td>;
                      }
                    })}</tr>))}
              </tbody>
            </table>
          </div>
          <Pagination
            paginationState={pagination}
            setPaginationState={setPagination}
            count={users.count||0}
          />
          <Popup
            show={dialog.show}
            handleClose={() => setDialog({ show: false, id: "", status: false })}
            heading={LOCAL_CONSTANTS.areYouSure}
            content={LOCAL_CONSTANTS.areYouSureRestrictUserAccess}
            handleSubmit={blockUnblockUser}
            id={dialog.id}
          />
          <SelectColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} show={show} handleClose={() => setShow(false)} iso="" columns={ORDER_TABLE_HEADERS} />

          <LogisticsModal
            visible={logisticsModal.visible}
            orderData={logisticsModal.orderData}
            logisticsForm={logisticsForm}
            submitting={submitting}
            onClose={handleLogisticsClose}
            onFormChange={handleLogisticsFormChange}
            onSuccess={handleLogisticsSuccess}
            setSubmitting={setSubmitting}
            isEditing={logisticsModal.isEditing}
          />

          <IccidModal
            visible={iccidModal.visible}
            orderData={iccidModal.orderData}
            iccidList={iccidList}
            selectedIccids={selectedIccids}
            iccidLoading={iccidLoading}
            submitting={submitting}
            onClose={handleIccidClose}
            onSuccess={handleIccidSuccess}
            setIccidList={setIccidList}
            setSelectedIccids={setSelectedIccids}
            setIccidLoading={setIccidLoading}
            setSubmitting={setSubmitting}
            onAddManually={() => setManualModalVisible(true)}
          />

        </div>
      </Layout>
      <Modal
        title="Add Order Manually"
        visible={manualModalVisible}
        onCancel={() => setManualModalVisible(false)}
        onOk={async () => {
          setManualSubmitting(true);
          try {
            if (!manualInput) {
              toast.error("Please enter a value");
              setManualSubmitting(false);
              return;
            }
            if (!iccidModal.orderData || !iccidModal.orderData._id) {
              toast.error("Order not found");
              setManualSubmitting(false);
              return;
            }
            await updateOrder(iccidModal.orderData._id, { iccid: manualInput, manuallyAdded: true });
            toast.success("ICCID assigned successfully");
            setManualModalVisible(false);
            setManualInput("");
            listUsers();
          } catch (error) {
            toast.error("Failed to assign ICCID");
          } finally {
            setManualSubmitting(false);
          }
        }}
        confirmLoading={manualSubmitting}
        okButtonProps={{ disabled: !manualInput || manualSubmitting }}
      >
        <input
          type="text"
          value={manualInput}
          onChange={e => setManualInput(e.target.value)}
          placeholder="Enter value"
          style={{ width: "100%" }}
        />
      </Modal>
      <Modal
        title="Cancel Order Remark"
        visible={cancelRemarkModal.visible}
        onCancel={() => setCancelRemarkModal({ visible: false, orderId: '', remarks: '' })}
        onOk={async () => {
          if (!cancelRemarkModal.remarks.trim()) {
            toast.error('Remark is required');
            return;
          }
          setCancelRemarkSubmitting(true);
          try {
            await updateOrder(cancelRemarkModal.orderId, { status: 'Canceled', remarks: cancelRemarkModal.remarks });
            toast.success('Order status updated successfully');
            setCancelRemarkModal({ visible: false, orderId: '', remarks: '' });
            listUsers();
          } catch (error) {
            toast.error('Failed to update order status');
          } finally {
            setCancelRemarkSubmitting(false);
          }
        }}
        confirmLoading={cancelRemarkSubmitting}
        okButtonProps={{ disabled: !cancelRemarkModal.remarks.trim() || cancelRemarkSubmitting }}
      >
        <div>
          <label htmlFor="cancel-remark-input">Please enter a remark for cancellation:</label>
          <textarea
            id="cancel-remark-input"
            rows={4}
            style={{ width: '100%', marginTop: 8 }}
            value={cancelRemarkModal.remarks}
            onChange={e => setCancelRemarkModal(modal => ({ ...modal, remarks: e.target.value }))}
            disabled={cancelRemarkSubmitting}
            placeholder="Enter remark..."
          />
        </div>
      </Modal>
      
    </>
  );
};

export default Orders;
